module.exports = __webpack_public_path__ + "static/media/checkBoxSelectedWhite.3591f670.svg";